var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inicio'),_c('servicos-de-suporte'),_c('amostra'),_c('sigilo-de-honorarios'),_c('free'),_c('equipe'),_c('empresa'),_c('fale'),_c('rodape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }